import { BrowserRouter, Route } from 'react-router-dom';
import { EditBaseController } from './app/main/gui/controllers/EditBaseController';
import UserRoutes from './app/main/gui/routes/UserRoutes';
import UserRoutesStore from './app/main/gui/routes/UserRoutesStore';
import { DeviceStateController } from './commonreact/main/services/devicestate/DeviceStateController';
import DeviceStateService from './commonreact/main/services/devicestate/DeviceStateService';
import { OnAppInit } from './app/main/logic/services/init/OnAppInit';
import './common/main/extensions/arrayextensions';
import { ModalOkCancel } from './commonreact/main/components/modals/modalok/ModalOkCancel';
import { ModalOkCancelController } from './commonreact/main/components/modals/modalok/ModalOKCancelController';
import { ModalVideoController } from './commonreact/main/components/modals/modalvideo/ModalVideoController';
import { useEffect } from 'react';
import { ModalVideo } from './commonreact/main/components/modals/modalvideo/ModalVideo';
import { ModalHiddenScreen } from './commonreact/main/components/modals/modalisbusy/ModalHiddenScreen';

function App() {

  const dsc = DeviceStateController({ deviceStateService: DeviceStateService.factory });
  const mvc = ModalVideoController({ isAutoPlay: true, dsc:dsc})
  const mokc = ModalOkCancelController({ title: "title", text: "text" });
  const ebc = EditBaseController({});

  new UserRoutesStore({ mokc: mokc, mvc: mvc, ebc: ebc, dsc });

  useEffect(() => {
    //ebc.setIsSubmitting(true)
    const load = async () => {
      new OnAppInit()
    };
    load();
  }, []);
    

  return (
    <>
      <ModalHiddenScreen show={ebc.isSubmitting} />
      <ModalOkCancel mokc={mokc} /> 
      <ModalVideo mvc={mvc} />

     <BrowserRouter>
        <UserRoutes ebc={ebc} dsc={dsc}  />
      </BrowserRouter>
    </>
  );
}

export default App;